import React, {
  useEffect,
  useState,
  ChangeEvent,
  useRef,
} from "react";
import {
  TextField, Grid, MenuItem, Button,
  IconButton, Typography, Box, Stack, Modal, Divider,
  CircularProgress, Tooltip,
  RadioGroup, Radio, Card, CardContent, Pagination, Skeleton, Tabs, Tab,
} from "@mui/material";
import "../generated_blogs.css";
import "./CreateCourse.module.css";        
import { useCreateCampaignMutation } from "../../../redux/api/promptApi";
import { toast } from "react-toastify";
import { useLazyCreateCheckoutSessionQuery } from "../../../redux/api/subscriptionApi";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { usePlanDetailsMutation, useCampaignDetailsMutation } from "../../../redux/api/productApi";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetpagefrocampaignMutation, useGetCnameEntriesMutation,
  useUpdateAutoPublishFlagMutation, useGetverifyscriptMutation, useCheckverifiedMutation,
} from "../../../redux/api/promptApi";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useAppSelector, useAppDispatch } from "../../../redux/store";
import axios from "axios";
import { useCampaignListMutation } from "../../../redux/api/promptApi";
import InfoIcon from "@mui/icons-material/Info";
import { getCookie } from "../../../utils/storageUtils";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PublishIcon from "@mui/icons-material/Publish";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import StarIcon from "@mui/icons-material/Star";
import MuiChip from "@mui/material/Chip";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { isMobile } from "react-device-detect";
import Checkbox from "@mui/material/Checkbox";

// The common sidebar + header lives in Ocesha_new_design (the parent shell
// that renders this component when activeItem === "course"). This page is
// pure content — same pattern as AuthorityEngine, SocialPost, etc.
const createCourseSlug = (
  title: string,
  id: string
) => {
  const slug = title
    ?.toLowerCase()
    ?.trim()
    ?.replace(/[^a-z0-9\s-]/g, "")
    ?.replace(/\s+/g, "-");

  return `${slug}-${id}`;
};

const ListingCourses = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { FromEdit } = location.state || {};
  const { campIdFrEdit } = location.state || {};

  // ── Page state ────────────────────────────────────────────────────
  const [planDetails, setPlanDetails] = useState<any>();
  const [campDetails, setCampDetails] = useState<any>();
  const [userDetails, setUserDetails] = useState<any>();
  const [openpaymentInstructModal, setOpenPaymentInstructModal] = useState<boolean>(false);
  const [confirmCancelSubscription, setConfirmCancelSubscription] = useState<boolean>(false);
  const [cancellingLoader, setCancellingLoader] = useState<boolean>(false);
  const user_email = localStorage.getItem("user_email") || getCookie("user_email") || "";
  const [courses, setCourses] = useState<any>();
  const [availableCourses, setAvailableCourses] = useState<any[]>([]);
  const [enrolledCourses, setEnrolledCourses] = useState<any[]>([]);
  const [mentorDetails, setMentorDetails] = useState<any>();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loadingcourses, setLoadingCourses] = useState<boolean>();
  const [enrolledCourseIds, setEnrolledCourseIds] = useState<string[]>([]);
  const limit = 12;

  const [getUserDetailsMutation] = useGetUserDetailsMutation();
  const [getuserPlanDetails] = usePlanDetailsMutation();
  const [getuserCampDetails] = useCampaignDetailsMutation();

  const [openGetPagesuccessModal, setOpenGetPageSuccessModal] = useState<boolean>(false);
  const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
  const [deleteCourseModal, setDeleteCourseModal] = useState<boolean>(false);
  const [deleteCourseId, setDeleteCourseId] = useState<string | null>(null);
  const [publishSuccessModal, setPublishSuccessModal] = useState<boolean>(false);

  interface BlogSuggestion {
    type: string; title: string; hook: string; source_reference: string;
    platform: string | string[]; estimated_engagement: string;
    content_angle: string; key_points: string[];
    image_url: string; image_url_small: string;
    source_url?: string;
    source_id?: string;
  }
  interface LoadingStates { [key: string]: boolean; }
  const [isPublishLoading, setIsPublishLoading] = useState<LoadingStates>({});
  const [currentSuggestion, setCurrentSuggestion] = useState<BlogSuggestion | null>(null);
  const [currentCourseForPublish, setCurrentCourseForPublish] = useState<any>(null);

  const [topics, setTopics] = useState<any>();
  const [topicsList, setTopicsList] = useState<boolean>(false);
  const [selectedTopic, setSelectedTopic] = useState<any>();
  // const [tabValue, setTabValue] = useState(0);
  const [tabValue, setTabValue] = useState<number | null>(null);

  const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

  const [selectedCourses, setSelectedCourses] = useState<string[]>([]);
  const [isBulkPublishing, setIsBulkPublishing] = useState(false);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);

  // ── Course-list fetchers ──────────────────────────────────────────
  const getCourselisting = async (currentPage = page) => {
    setCourses([]);
    setLoadingCourses(true);
    try {
      const res = await axios.get(`${apiUrl}/api/prompts/courses/by-user?user_email=${user_email}&page=${currentPage}&limit=${limit}`);
      console.log("FROM ADMIN API", res.data.courses);
      setCourses(res?.data?.courses);
      setMentorDetails(res?.data?.mentor);
      setTotalPages(res?.data?.pagination?.total_pages);
      setTotalCount(res?.data?.pagination?.total);
    } catch (error: any) {
      console.log("Error fetching courses listing=>", error);
      toast.error(error);
    } finally {
      setLoadingCourses(false);
    }
  };

  const getAllCourselisting = async (currentPage = page) => {
    setCourses([]);
    setLoadingCourses(true);
    try {
      const res = await axios.get(`${apiUrl}/api/prompts/courses/all?search=${""}&page=${currentPage}&limit=${limit}`);
      console.log("FROM AVAILABLE API", res.data.courses);
      // setCourses(res?.data?.courses);
      setAvailableCourses(res.data.courses || []);
      setTotalPages(res?.data?.pagination?.total_pages);
      setTotalCount(res?.data?.pagination?.total);
    } catch (error: any) {
      console.log("Error fetching courses listing=>", error);
      toast.error(error);
    } finally {
      setLoadingCourses(false);
    }
  };

  const getenrolledCourselisting = async (currentPage = page) => {
    setCourses([]);
    setLoadingCourses(true);
    try {
      const res = await axios.get(`${apiUrl}/api/student/courses/enrolled?user_email=${user_email}&page=${currentPage}&limit=${limit}`);
      const enrolledCourses = res?.data?.courses || [];
      console.log("FROM ENROLLED API", enrolledCourses);
      // setCourses(enrolledCourses);
      setEnrolledCourses(enrolledCourses);
      setEnrolledCourseIds(enrolledCourses.map((c: any) => c._id));
      setTotalPages(res?.data?.pagination?.total_pages);
      setTotalCount(res?.data?.pagination?.total);
    } catch (error: any) {
      console.log("Error fetching courses listing=>", error);
      toast.error(error);
    } finally {
      setLoadingCourses(false);
    }
  };

  const handleDeleteCourse = async (courseId: string) => {
    setDeleteCourseModal(false);
    setDeleteCourseId(null);
    try {
      const response = await axios.delete(`${apiUrl}/api/prompts/delete_course/${courseId}`);
      if (response.status === 200 || response.status === 204) {
        toast.success('Course deleted successfully');
        setCourses((prev: any) => Array.isArray(prev) ? prev.filter((c: any) => c._id !== courseId) : prev);
        setTimeout(() => {
          navigate(0);
        }, 1200);
      } else {
        toast.error('Failed to delete course');
      }
    } catch (err: any) {
      console.error(err);
      toast.error('Failed to delete course');
    }
  };

  useEffect(() => {
    console.log("COURSES STATE UPDATED", tabValue, courses?.length);
  }, [courses]);

  const renderStars = (rating: number) => {
    const safeRating = Math.round(rating || 0);
    return Array.from({ length: 5 }, (_, index) => (
      <StarIcon key={index} style={{ color: index < safeRating ? "#f5b50a" : "#ccc", fontSize: "18px" }} />
    ));
  };

  // If we landed here as a standalone route, bounce into the parent shell
  // (Ocesha_new_design) with activeItem="course" preset so the common
  // sidebar + header render.
  useEffect(() => {
    if (location.pathname === "/codegenie/generated-courses") {
      localStorage.setItem("activeItem", "course");
      navigate("/codegenie/generated-blogs?activeItem=course", {
        replace: true,
        state: location.state,
      });
    }
  }, []);

  /* useEffect(() => {
    if (userDetails?.role === "student" && tabValue === 0) {
      getAllCourselisting(page);
    } else if (userDetails?.role === "student" && tabValue === 1) {
      getenrolledCourselisting(page);
    } else {
      getCourselisting(page);
    }
  }, [page, userDetails?.role, tabValue]); */

  useEffect(() => {
    if (!userDetails || tabValue === null) return;

    if (userDetails.role === "student") {
      // Student
      if (tabValue === 0) {
        getAllCourselisting(page);
      } else {
        getenrolledCourselisting(page);
      }
    } else if (userDetails.role === "user") {
      // User
      if (tabValue === 0) {
        getCourselisting(page);          // Only courses created by this user
      } else {
        getenrolledCourselisting(page);  // Courses they enrolled in
      }
    } else {
      // Admin
      getCourselisting(page);
    }
  }, [page, tabValue, userDetails]);

  useEffect(() => { localStorage.removeItem("publishingCampId"); }, []);


  const displayCourses =
    userDetails?.role === "student"
      ? tabValue === 1
        ? enrolledCourses
        : availableCourses
      : userDetails?.role === "user"
        ? tabValue === 1
          ? enrolledCourses
          : courses
        : courses;

  // ── Publish-from-course flow ──────────────────────────────────────
  // const handlePublishIconClick = async (course: any) => {
  //   const courseId = course._id;
  //   setIsPublishLoading((prev) => ({ ...prev, [courseId]: true }));
  //   setCurrentCourseForPublish(course);

  //   const emailToUse = user_email || getCookie('user_email') || '';

  //   try {
  //     // Use the clicked course's own title and description directly
  //     const courseTitle = course.title || '';
  //     const courseDescription = course.description || '';

  //     // Build the public course URL using email as profileId + title slug
  //     const profileId =
  //       localStorage.getItem('profile_id') ||
  //       localStorage.getItem('user_id') ||
  //       emailToUse;
  //     const titleSlug = courseTitle
  //       .toLowerCase()
  //       .replace(/[^a-z0-9\s-]/g, '')
  //       .trim()
  //       .replace(/\s+/g, '-');
  //     const resolvedCourseUrl = titleSlug
  //       ? `https://podcastclips.ocesha.ai/${encodeURIComponent(profileId)}/course/${titleSlug}`
  //       : '';

  //     // Trigger suggestions in background (for the suggestions panel in PublishScheduleClip)
  //     let suggestions: any[] = [];
  //     try {
  //       const triggerRes = await axios.post(
  //         `${apiUrl}/api/prompts/process_course_suggestions_trigger`,
  //         { course_id: courseId, user_email: emailToUse },
  //         { headers: { 'Content-Type': 'application/json' } },
  //       );
  //       const taskId = triggerRes.data?.task_id || triggerRes.data?.id;

  //       if (taskId) {
  //         const pollTaskStatus = (): Promise<any> =>
  //           new Promise((resolve, reject) => {
  //             const interval = setInterval(async () => {
  //               try {
  //                 const statusRes = await axios.get(`${apiUrl}/api/prompts/task_status`, {
  //                   params: { task_id: taskId },
  //                   headers: { 'Content-Type': 'application/json' },
  //                 });
  //                 if (statusRes.data?.state === 'done') {
  //                   clearInterval(interval);
  //                   resolve(statusRes.data);
  //                 }
  //               } catch (err) { clearInterval(interval); reject(err); }
  //             }, 5000);
  //           });

  //         await pollTaskStatus();

  //         const suggestRes = await axios.post(
  //           `${apiUrl}/api/prompts/course_suggestions`,
  //           { user_email: emailToUse, video_id: courseId },
  //           { headers: { 'Content-Type': 'application/json' } },
  //         );
  //         const raw =
  //           suggestRes.data?.result?.data?.course_suggestions ||
  //           suggestRes.data?.data?.course_suggestions ||
  //           suggestRes.data?.course_suggestions ||
  //           [];
  //         if (Array.isArray(raw)) suggestions = raw;
  //       }
  //     } catch (suggestErr) {
  //       console.warn('[ListingCourses] suggestions fetch failed (non-blocking):', suggestErr);
  //     }

  //     navigate('/ocesha/publish-schedule-clip', {
  //       state: {
  //         postContent: courseDescription,
  //         postId: courseId || '',
  //         clipTitle: courseTitle,
  //         clipThumbnail: course.thumbnail_url || course.image_path_small || '',
  //         platform: 'twitter',
  //         blogId: courseId || '',
  //         blogUrl: resolvedCourseUrl,
  //         sourceType: 'course',
  //         allSuggestions: suggestions,
  //       },
  //     });
  //   } catch (error) {
  //     console.error('Error in handlePublishIconClick:', error);
  //     toast.error('Something went wrong. Please try again.');
  //     // Fallback: navigate with course data directly
  //     const profileId = localStorage.getItem('profile_id') || localStorage.getItem('user_id') || emailToUse;
  //     const titleSlug = (course.title || '').toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-');
  //     navigate('/ocesha/publish-schedule-clip', {
  //       state: {
  //         postContent: course.description || '',
  //         postId: courseId || '',
  //         clipTitle: course.title || '',
  //         clipThumbnail: course.thumbnail_url || course.image_path_small || '',
  //         platform: 'twitter',
  //         blogId: courseId || '',
  //         blogUrl: titleSlug ? `https://podcastclips.ocesha.ai/${encodeURIComponent(profileId)}/course/${titleSlug}` : '',
  //         sourceType: 'course',
  //       },
  //     });
  //   } finally {
  //     setIsPublishLoading((prev) => ({ ...prev, [courseId]: false }));
  //   }
  // };


  // Build a fallback suggestion from the course itself (used if the task
  // returns nothing, so generate still proceeds)
  const buildFallbackSuggestion = (course: any): BlogSuggestion => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = course.description || '';
    const plainText = tempDiv.innerText || course.description || '';
    return {
      type: 'Social Post',
      title: course.title || course.name || '',
      hook: plainText.substring(0, 300),
      source_reference: course.title || '',
      platform: 'twitter',
      estimated_engagement: 'high',
      content_angle: 'informative',
      key_points: [
        plainText.substring(0, 150),
        plainText.substring(150, 300),
        plainText.substring(300, 450),
      ],
      image_url: course.image_path || course.thumbnail_url || '',
      image_url_small: course.image_path_small || '',
      source_url: '',
      source_id: course._id,
    };
  };

  const pollTaskStatus = async (taskId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const statusRes = await axios.get(
            `${apiUrl}/api/prompts/task_status`,
            {
              params: { task_id: taskId },
              headers: { "Content-Type": "application/json" },
            }
          );

          const statusData = statusRes.data;

          if (statusData?.state === "done") {
            clearInterval(interval);
            clearTimeout(timeout);
            resolve(statusData);
          }

          if (statusData?.state === "failed") {
            clearInterval(interval);
            clearTimeout(timeout);
            reject(new Error("Task failed"));
          }
        } catch (err) {
          clearInterval(interval);
          clearTimeout(timeout);
          reject(err);
        }
      }, 5000);

      const timeout = setTimeout(() => {
        clearInterval(interval);
        resolve({
          state: "timeout",
          result: null,
        });
      }, 60000);
    });
  };

  const handlePublishIconClick = async (course: any) => {
    const courseId = course._id;
    setIsPublishLoading((prev) => ({ ...prev, [courseId]: true }));
    setCurrentCourseForPublish(course);

    const emailToUse = user_email || getCookie('user_email') || '';

    // Public course URL → used as source_url on the generated post
    const profileId =
      localStorage.getItem('profile_id') ||
      localStorage.getItem('user_id') ||
      emailToUse;
    const titleSlug = (course.title || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-');
    const resolvedCourseUrl = titleSlug
      ? `{process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}/course/${encodeURIComponent(emailToUse)}/${titleSlug}`
      : '';

    /*
    // Start from a fallback; upgrade it if the task returns a real suggestion
    const fallback = buildFallbackSuggestion(course);
    let resolvedSuggestion: BlogSuggestion = fallback;
    let resolvedCourse: any = course;

    // 1) Trigger + poll task_status (same flow as Blogs_Section)
    try {
      const triggerRes = await axios.post(
        `${apiUrl}/api/prompts/process_course_suggestions_trigger`,
        { course_id: courseId, user_email: emailToUse },
        { headers: { 'Content-Type': 'application/json' } },
      );
      const taskId = triggerRes.data?.task_id || triggerRes.data?.id || triggerRes.data;

      if (taskId) {
        const doneData = await pollTaskStatus(taskId);

        // Pull course_suggestions out of the task result (mirrors blog_suggestions)
        let suggestions: any[] = [];
        const resultData = doneData?.result?.data;
        if (resultData?.course_suggestions && Array.isArray(resultData.course_suggestions)) {
          suggestions = resultData.course_suggestions;
        } else if (Array.isArray(resultData)) {
          suggestions = resultData;
        } else if (doneData?.result && Array.isArray(doneData.result)) {
          suggestions = doneData.result;
        }

        // If the task result didn't carry suggestions inline, fetch them once
        if (suggestions.length === 0) {
          try {
            const suggestRes = await axios.post(
              `${apiUrl}/api/prompts/course_suggestions`,
              { user_email: emailToUse, video_id: courseId },
              { headers: { 'Content-Type': 'application/json' } },
            );
            const raw =
              suggestRes.data?.result?.data?.course_suggestions ||
              suggestRes.data?.data?.course_suggestions ||
              suggestRes.data?.course_suggestions ||
              [];
            if (Array.isArray(raw)) suggestions = raw;
          } catch (suggestErr) {
            console.warn('[ListingCourses] course_suggestions fallback failed:', suggestErr);
          }
        }

        if (suggestions.length > 0) {
          const raw = suggestions[0] as any;
          resolvedSuggestion = {
            type: raw.type || 'Social Post',
            title: raw.title || course.title || '',
            hook: raw.hook || raw.adaptation?.twitter || course.description || '',
            source_reference: raw.source_reference || raw.title || course.title || '',
            platform: Array.isArray(raw.platforms) ? raw.platforms[0] : raw.platform || 'twitter',
            estimated_engagement: raw.estimated_engagement || 'high',
            content_angle: raw.content_angle || 'informative',
            key_points: Array.isArray(raw.key_points) ? raw.key_points : [],
            image_url: raw.image_url || '',
            image_url_small: raw.image_url_small || '',
            source_url: raw.course_url || raw.blog_url || '',
          };
          resolvedCourse = { ...course, ...raw };
        }
      }
    } catch (error) {
      console.error('Error fetching course suggestions; using fallback:', error);
    }*/

    // Build suggestion directly from course
    const resolvedSuggestion: BlogSuggestion = buildFallbackSuggestion(course);
    const resolvedCourse = course;

    // 2) Generate the post from the resolved suggestion
    try {
      const keyPointsArray = Array.isArray(resolvedSuggestion.key_points)
        ? resolvedSuggestion.key_points
        : [resolvedSuggestion.hook.substring(0, 150)];
      const platform = Array.isArray(resolvedSuggestion.platform)
        ? (resolvedSuggestion.platform as any)[0] || 'linkedin'
        : resolvedSuggestion.platform || 'linkedin';

      const payload = {
        suggestion: {
          type: 'dummy_course_post',
          title: resolvedSuggestion.title,
          hook: resolvedSuggestion.hook,
          source_reference: resolvedSuggestion.source_reference || resolvedSuggestion.title,
          platform,
          estimated_engagement: resolvedSuggestion.estimated_engagement || 'high',
          content_angle: resolvedSuggestion.content_angle || 'informative',
          key_points: keyPointsArray.length > 0 ? keyPointsArray : [resolvedSuggestion.hook.substring(0, 150)],
          image_url: resolvedSuggestion.image_url || resolvedCourse.image_path || resolvedCourse.thumbnail_url || '',
          image_url_small: resolvedSuggestion.image_url_small || resolvedCourse.image_path_small || '',
          source_url: resolvedSuggestion.source_url || resolvedCourseUrl || '',
          source_id: resolvedSuggestion.source_id,
        },
      };

      const response = await axios.post(
        `${apiUrl}/api/prompts/api/posts/generate?user_email=${encodeURIComponent(emailToUse)}`,
        payload,
        { headers: { 'Content-Type': 'application/json', accept: 'application/json' } },
      );

      if (response.data.status === 'success') {
        //toast.success('Post generated & queued for publishing');
        //setPublishSuccessModal(true);

        const post = response.data.posts[0];

        const returnDomain = (process.env.REACT_APP_RETURN_DOMAIN_NAME || "").replace(/\/$/, "");
        const contentUrl = (post.content_url || "").replace(/^\//, "");
        navigate('/ocesha/publish-schedule-clip', {
          state: {
            postContent: post?.content,
            postId: courseId || '',
            clipTitle: post.suggestion_title || course.title,
            clipThumbnail: post.image_url || course.thumbnail_url || course.image_path_small || '',
            platform: post.platform || "",
            blogId: courseId || '',
            blogUrl: contentUrl ? `${returnDomain}/${contentUrl}` : "",
            sourceType: 'course',
            //allSuggestions: suggestions,
          },
        });
      } else {
        toast.error('Failed to generate post or duplicate post');
      }
    } catch (error) {
      console.error('Generate error in handlePublishIconClick:', error);
      toast.error('Something went wrong generating the post');
    } finally {
      setIsPublishLoading((prev) => ({ ...prev, [courseId]: false }));
    }
  };

  // ── User details + plan / campaign meta ───────────────────────────
  const fetchPlanDatas = async () => {
    try {
      const response = await getuserPlanDetails({ email: user_email || getCookie("user_email") || "", campaignid: "" });
      if ("data" in response) setPlanDetails(response.data.data);
    } catch (error) { console.log(error); }
  };
  useEffect(() => { fetchPlanDatas(); }, []);

  const fetchCampDatas = async () => {
    try {
      const response = await getuserCampDetails({ campaignid: campIdFrEdit || "" });
      if ("data" in response) setCampDetails(response.data.data);
    } catch (error) { console.log(error); }
  };
  useEffect(() => { if (FromEdit === "startEditing") fetchCampDatas(); }, []);

  const fetchData = async () => {
    try {
      const response = await getUserDetailsMutation({
        email: user_email || getCookie("user_email") || "",
        filter: "", start_date: "", end_date: "",
      });
      if ("data" in response) {
        const userData = response.data.data;
        setUserDetails(userData);
        localStorage.setItem("student_id", userData._id);
        localStorage.setItem("userid", userData._id);
      }
    } catch (error) { console.log(error); }
  };
  useEffect(() => { fetchData(); }, []);

  useEffect(() => {
    if (!userDetails) return;

    if (userDetails.role === "student") {
      setTabValue(1); // Enrolled
    } else if (userDetails.role === "user") {
      setTabValue(0); // My Courses
    } else {
      setTabValue(0);
    }
  }, [userDetails]);

  useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [page]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => { setTabValue(newValue); };

  const handleBulkPublish = async () => {
    try {
      setIsBulkPublishing(true);

      const response = await axios.post(
        `${apiUrl}/api/prompts/process_multiple_course_suggestions_trigger`,
        {
          user_email: user_email,
          course_ids: selectedCourses.join(","),
        }
      );

      const taskId = response?.data?.task_id;

      if (!taskId) {
        toast.error("Failed to start publishing");
        return;
      }

      const result = await pollTaskStatus(taskId);

      console.log("MULTIPLE COURSE RESULT:", result);

      toast.success(
        "Post generation initiated, will be completed in few seconds. Head to your Dashboard and check the Generated Content List shortly."
      );

      setSelectedCourses([]);

    } catch (error) {
      console.error(error);
      toast.error("Bulk generate failed");
    } finally {
      setIsBulkPublishing(false);
    }
  };

  const allSelected =
    displayCourses?.length > 0 &&
    selectedCourses.length === displayCourses.length;

  const someSelected =
    selectedCourses.length > 0 &&
    selectedCourses.length < courses?.length;

  const handleBulkDelete = async () => {
    try {
      setIsBulkDeleting(true);

      const response = await axios.post(
        `${apiUrl}/api/prompts/delete_course_multiple`,
        null,
        {
          params: {
            course_ids: selectedCourses.join(","),
          },
        }
      );

      if (response.data?.status === "success") {
        toast.success(response.data.message || "Courses deleted successfully");

        // Remove deleted courses from UI
        // setCourses((prev: any) =>
        //   Array.isArray(prev)
        //     ? prev.filter(
        //         (course: any) =>
        //           !selectedCourses.includes(course._id)
        //       )
        //     : prev
        // );

        // setSelectedCourses([]);
        setTimeout(() => {
          navigate(0);
        }, 1200);
      } else {
        toast.error("Failed to delete courses");
      }
    } catch (error) {
      console.error(error);
      toast.error("Bulk delete failed");
    } finally {
      setIsBulkDeleting(false);
    }
  };

  const hideBulkSelection =
    userDetails?.role === "student" ||
    (userDetails?.role === "user" && tabValue === 1);

  const hideCourseActions =
    userDetails?.role === "student" ||
    (userDetails?.role === "user" && tabValue === 1);


  // ─────────────────────────────────────────────────────────────────
  // RENDER — content only (parent shell provides sidebar + header)
  // ─────────────────────────────────────────────────────────────────
  return (
    <>
      <Box sx={{
        background: "transparent",
        color: "#fff",
        fontFamily: "'Inter', -apple-system, sans-serif",
      }}>

        <Box sx={{ px: { xs: 0, md: 0 }, py: 2 }}>

          {/* HEADER ROW */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography color="#fff" fontWeight={600} fontSize="32px">
              My Courses
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {/* <Button
                variant="outlined"
                onClick={() => {
                  window.open(
                    `${window.location.origin}/codegenie/courses-directory/${userDetails?.profile_id}`,
                    "_blank"
                  );
                }}
                sx={{
                  color: "#fff",
                  borderColor: "rgba(255,255,255,0.4)",
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    borderColor: "#4BA5EB",
                    background: "rgba(75,165,235,0.08)",
                  },
                }}
              >
                Open Public Course Directory
              </Button> */}

              {!hideBulkSelection && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Checkbox
                  checked={allSelected}
                  indeterminate={someSelected}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedCourses(displayCourses.map((course: any) => course._id));
                    } else {
                      setSelectedCourses([]);
                    }
                  }}
                  sx={{
                    color: "#fff",
                    "&.Mui-checked": {
                      color: "#4BA5EB",
                    },
                  }}
                />

                <Typography color="#fff" fontSize="14px">
                  {allSelected ? "Unselect All" : "Select All"}
                </Typography>

                {/*<Button
                  variant="contained"
                  disabled={
                    selectedCourses.length === 0 ||
                    isBulkPublishing
                  }
                  onClick={handleBulkPublish}
                  startIcon={
                    isBulkPublishing ? (
                      <CircularProgress
                        size={18}
                        sx={{ color: "white" }}
                      />
                    ) : null
                  }
                >
                  {isBulkPublishing
                    ? "Generating..."
                    : `Generate Post (${selectedCourses.length})`}
                </Button>*/}

                <Button
                  variant="outlined"
                  color="error"
                  disabled={
                    selectedCourses.length === 0 ||
                    isBulkDeleting
                  }
                  onClick={() => setBulkDeleteModal(true)}
                >
                  {isBulkDeleting
                    ? "Deleting..."
                    : `Delete Selected (${selectedCourses.length})`}
                </Button>
              </Box>
              )}
            </Box>
          </Box>

          {/* TABS (ONLY FOR STUDENT) */}
          {["user"].includes(userDetails?.role) && (
            <Tabs value={tabValue} onChange={handleTabChange}
              textColor="inherit" indicatorColor="primary"
              sx={{
                mb: 3,
                "& .MuiTab-root": { color: "#9CA3AF", textTransform: "none", fontSize: "18px" },
                "& .Mui-selected": { color: "#fff", fontWeight: 600 },
              }}>
              <Tab label="My Courses" />
              <Tab label="Enrolled Courses" />
            </Tabs>
          )}

          <Grid container spacing={3}>
            {loadingcourses ? (
              [...Array(4)].map((_, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card sx={{
                    height: "100%", background: "transparent",
                    borderRadius: "14px", boxShadow: "none", overflow: "hidden",
                    display: "flex", flexDirection: "column",
                    border: "1px solid #2D2D2D",
                  }}>
                    <Box sx={{ position: "relative", height: 170, overflow: "hidden", p: 2 }}>
                      <Skeleton variant="rounded" width="100%" height="100%" sx={{ borderRadius: "20px" }} />
                    </Box>
                    <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.8, p: 2 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Skeleton variant="text" width="70%" height={26} />
                        <Skeleton variant="circular" width={24} height={24} />
                      </Box>
                      <Skeleton variant="text" width="40%" height={18} />
                      <Skeleton variant="text" width="100%" height={20} />
                      <Skeleton variant="text" width="80%" height={20} />
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Skeleton variant="rounded" width={110} height={24} />
                        <Skeleton variant="rounded" width={80} height={24} />
                      </Stack>
                      <Skeleton variant="text" width="30%" height={22} />
                      <Box sx={{ flexGrow: 1 }} />
                      <Skeleton variant="rounded" width="100%" height={36} />
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : displayCourses && displayCourses.length > 0 ? (
              displayCourses?.map((course: any) => {
                const isEnrolled = enrolledCourseIds.includes(course._id);

                const rawImage =
                  course.image_path ||
                  course.thumbnail_url ||
                  course.image_url ||
                  course.image_path_small ||
                  course.image ||
                  "https://images.unsplash.com/photo-1521737604893-d14cc237f11d";

                const imageSrc = /^(https?:)?\/\//i.test(rawImage)
                  ? rawImage
                  : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${rawImage.startsWith("/") ? "" : "/"
                  }${rawImage}`;

                return (
                  <Grid item xs={12} sm={6} md={3} key={course._id}>
                    <Card sx={{
                      height: "100%", background: "transparent",
                      borderRadius: "14px", boxShadow: "none", overflow: "hidden",
                      display: "flex", flexDirection: "column",
                      border: "1px solid #2D2D2D",
                    }}>
                      <Box sx={{ position: "relative", height: 220, overflow: "hidden", p: 2 }}>
                        <Box component="img"
                          src={imageSrc}
                          alt={course.title}
                          sx={{
                            width: "100%", height: "100%", objectFit: "cover",
                            display: "block", borderRadius: "14px", cursor: "pointer",
                            imageRendering: "auto",
                          }}
                          onClick={() => {
                            if (isEnrolled && tabValue === 0) return;
                            navigate(
                              userDetails?.role === "student" && tabValue === 0
                                ? "/codegenie/individual-course"
                                : "/codegenie/course-detail",
                              {
                                state: userDetails?.role === "student" && tabValue === 0
                                  ? { studentEmail: user_email, courseId: course._id }
                                  : { courseId: course._id },
                              }
                            );
                          }}
                        />
                        {!hideBulkSelection && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              zIndex: 10,
                              background: "rgba(0,0,0,0.7)",
                              borderRadius: "50%",
                            }}
                          >
                            <Checkbox
                              checked={selectedCourses.includes(course._id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedCourses(prev => [...prev, course._id]);
                                } else {
                                  setSelectedCourses(prev =>
                                    prev.filter(id => id !== course._id)
                                  );
                                }
                              }}
                              sx={{
                                color: "#fff",
                                "&.Mui-checked": {
                                  color: "#4BA5EB",
                                },
                              }}
                            />
                          </Box>
                        )}

                      </Box>

                      {!hideCourseActions && (
                        <Box sx={{
                          display: "flex", justifyContent: "flex-end", alignItems: "center",
                          gap: "4px", px: 1.5, py: 0.75, borderBottom: "1px solid #2D2D2D",
                        }}>
                          <Tooltip title="View Course">
                            <IconButton size="small"
                              onClick={() => navigate(`/course/${createCourseSlug(
                                course.title,
                                course._id
                              )}`)/* ("/codegenie/course-detail", { state: { courseId: course._id } }) */}
                              sx={{ color: "#9ca3af", border: "1px solid #30363d", borderRadius: "6px", padding: "4px", '&:hover': { color: "#3b82f6", borderColor: "#3b82f6", backgroundColor: "rgba(59,130,246,0.1)" } }}>
                              <VisibilityOutlinedIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Course">
                            <IconButton size="small"
                              onClick={() => navigate("/codegenie/edit-course", { state: { courseId: course._id } })}
                              sx={{ color: "#9ca3af", border: "1px solid #30363d", borderRadius: "6px", padding: "4px", '&:hover': { color: "#3b82f6", borderColor: "#3b82f6", backgroundColor: "rgba(59,130,246,0.1)" } }}>
                              <EditOutlinedIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Course">
                            <IconButton size="small"
                              onClick={() => { setDeleteCourseId(course._id); setDeleteCourseModal(true); }}
                              sx={{ color: "#9ca3af", border: "1px solid #30363d", borderRadius: "6px", padding: "4px", '&:hover': { color: "#ef4444", borderColor: "#ef4444", backgroundColor: "rgba(239,68,68,0.1)" } }}>
                              <DeleteOutlineIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Publish">
                            <IconButton size="small"
                              onClick={() => handlePublishIconClick(course)}
                              disabled={!!isPublishLoading[course._id]}
                              sx={{ color: "#9ca3af", border: "1px solid #30363d", borderRadius: "6px", padding: "4px", '&:hover': { color: "#10b981", borderColor: "#10b981", backgroundColor: "rgba(16,185,129,0.1)" } }}>
                              {isPublishLoading[course._id] ? <CircularProgress size={14} sx={{ color: "#4BA5EB" }} /> : <PublishIcon sx={{ fontSize: "16px" }} />}
                            </IconButton>
                          </Tooltip>
                        </Box>
                      )}

                      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.8, p: 2 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                          <Typography fontSize="20px" color="#ffffff"
                            sx={{ textAlign: "left", cursor: "pointer" }}
                            onClick={() => {
                              if (isEnrolled && tabValue === 0) return;
                              navigate(
                                userDetails?.role === "student" && tabValue === 0
                                  ? "/codegenie/individual-course"
                                  : `/course/${createCourseSlug(
                                    course.title,
                                    course._id
                                  )}`/* "/codegenie/course-detail" */,
                                {
                                  state: userDetails?.role === "student" && tabValue === 0
                                    ? { studentEmail: user_email, courseId: course._id }
                                    : { courseId: course._id },
                                },
                              );
                            }}>
                            {/* {course.title ? (course.title?.slice(0, 18) + "...") : ''} */}
                            {
                              course?.title
                                ? course.title.replace(/"/g, "").slice(0, 18) + "..."
                                : course?.name
                                  ? course.name.replace(/"/g, "").slice(0, 18) + "..."
                                  : ""
                            }
                          </Typography>
                        </Box>
                        {(course?.user?.name || course?.user?.first_name || mentorDetails) && (<Typography fontSize="14px" color="#fff" fontWeight={"lighter"}>
                          by {course?.user?.name || course?.user?.first_name || mentorDetails?.name || mentorDetails?.email}
                        </Typography>)}
                        <Typography fontSize="18px" color="#F3F3F3"
                          sx={{ minHeight: 34, mt: 1, fontWeight: "lighter", textAlign: "left" }}>
                          {course.description?.slice(0, 40) + "..."}
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box display="flex">{renderStars(course?.average_rating)}</Box>
                          <Typography fontSize="14px" fontWeight={600}>
                            {course?.average_rating ?? 0}
                          </Typography>
                          <Typography fontSize="13px" color="gray">
                            {course?.total_reviews ?? 0} reviews
                          </Typography>
                        </Box>
                        <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                          <Typography fontWeight={600} color="#fff" fontSize="20px">
                            ${course.suggested_price + " USD"}
                          </Typography>
                        </Stack>
                        <Box sx={{ flexGrow: 1 }} />
                        <Button fullWidth variant="contained"
                          disabled={isEnrolled && tabValue === 0}
                          sx={{
                            mt: 1, textTransform: "none", borderRadius: "4px",
                            background: isEnrolled && tabValue === 0 ? "#6b7280" : "linear-gradient(90deg,#2563eb,#1d9bf0)",
                            fontSize: "16px", py: 0.8, color: "#fff",
                            filter: isEnrolled && tabValue === 0 ? "blur(0.3px)" : "none",
                            pointerEvents: isEnrolled && tabValue === 0 ? "none" : "auto",
                          }}
                          onClick={() => {
                            if (isEnrolled && tabValue === 0) return;
                            navigate(
                              userDetails?.role === "student" && tabValue === 0
                                ? "/codegenie/individual-course"
                                : `/course/${createCourseSlug(
                                  course.title,
                                  course._id
                                )}`,/* "/codegenie/course-detail", */
                              {
                                state: userDetails?.role === "student" && tabValue === 0
                                  ? { studentEmail: user_email, courseId: course._id }
                                  : { courseId: course._id },
                              },
                            );
                          }}>
                          {isEnrolled && tabValue === 0 ? "Enrolled" : tabValue === 1 ? "Learn Course" : "View Course"}{" "}
                          {!isEnrolled && <ArrowForwardIcon />}
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })
            ) : (
              <Grid item xs={12}>
                <Typography sx={{ textAlign: "center", color: "#fff", mt: 4, fontSize: "18px" }}>
                  No data available
                </Typography>
              </Grid>
            )}
          </Grid>

          {displayCourses && displayCourses.length > 0 && (
            <Box
              mt={4}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  fontSize: "14px",
                }}
              >
                Total Courses: {totalCount}
              </Typography>

              <Typography
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  fontSize: "14px",
                }}
              >
                Page {page} of {totalPages}
              </Typography>

              <Pagination
                count={totalPages}
                page={page}
                onChange={(e: any, value: any) => setPage(value)}
                color="primary"
                sx={{
                  '& .MuiPaginationItem-root': {
                    backgroundColor: '#ffffffff',
                    color: '#1f1e1eff',
                    borderRadius: '4px',
                    padding: '0.4rem',
                    fontSize: '0.875rem',
                    margin: '0 0.2rem',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#7caef0ff',
                    color: '#f4f6f8ff',
                    border: '1px solid #8d9092ff'
                  },
                  '& .MuiPaginationItem-ellipsis': {
                    backgroundColor: 'transparent',
                    color: '#ffffffff',
                  },
                  '& .MuiPaginationItem-icon': {
                    color: '#636566ff',
                  },
                }}
              />
            </Box>
          )}
        </Box>

      </Box>

      {/* ═══════════════ MODALS ═══════════════ */}

      {/* Publish Success Modal */}
      <Modal open={publishSuccessModal} onClose={() => setPublishSuccessModal(false)}
        aria-labelledby="publish-success-modal">
        <Box sx={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '380px', bgcolor: '#1a1a2e',
          borderRadius: '12px', boxShadow: '0px 8px 32px rgba(0,0,0,0.5)',
          p: 4, '&:focus': { outline: 'none' }, textAlign: 'center',
        }}>
          <TaskAltIcon sx={{ color: '#10b981', fontSize: 44, mb: 1 }} />
          <Typography sx={{ color: '#fff', fontWeight: 700, mb: 1, fontSize: '16px' }}>
            Post generated & queued for publishing
          </Typography>
          <Typography sx={{ color: '#aaa', fontSize: '13px', mb: 3 }}>
            Your post has been created successfully. You can view it in your content list.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="outlined" sx={{ color: '#aaa', borderColor: '#555', textTransform: 'none' }}
              onClick={() => setPublishSuccessModal(false)}>
              Close
            </Button>
            <Button variant="contained"
              sx={{ background: 'linear-gradient(90deg,#2563eb,#1d9bf0)', textTransform: 'none', fontWeight: 600 }}
              onClick={() => {
                localStorage.setItem('activeItem', 'authority');
                setTimeout(() => { window.location.reload(); }, 100);
              }}>
              Go to Content List
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={openpaymentInstructModal}
        aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
        <Box sx={{
          position: "absolute" as "absolute", top: "50%", left: "50%",
          display: "flex", flexDirection: "column", alignItems: "center",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "95%" : 600,
          bgcolor: "background.paper", border: "2px solid #000",
          boxShadow: 24, pt: 2, px: 4, pb: 3,
        }}>
          <PriorityHighIcon style={{ color: "yellow", fontSize: "38px" }} />
          <p id="child-modal-description" style={{ textAlign: "center" }}>
            Please make a payment to complete your process.
          </p>
          <Stack flexDirection="row">
            <Button onClick={() => setOpenPaymentInstructModal(false)} variant="contained" sx={{ mr: 2 }}>Pay Now</Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={openGetPagesuccessModal} onClose={() => setOpenGetPageSuccessModal(false)}
        aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
        <Box sx={{
          position: "absolute" as "absolute", top: "50%", left: "50%",
          display: "flex", flexDirection: "column", alignItems: "center",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "95%" : 600,
          bgcolor: "background.paper", border: "2px solid #000",
          boxShadow: 24, pt: 2, px: 4, pb: 3,
        }}>
          <TaskAltIcon style={{ color: "green", fontSize: "40px" }} />
          <p id="child-modal-description" style={{ textAlign: "center" }}>
            We have generated your first blogs. We will automatically generate new blogs daily per your selected plan.
          </p>
          <Stack flexDirection="row">
            <Button onClick={() => setOpenGetPageSuccessModal(false)} variant="contained" sx={{ mr: 2 }}>Close</Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={confirmCancelSubscription} onClose={() => setConfirmCancelSubscription(false)}
        aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
        <Box sx={{
          position: "absolute" as "absolute", top: "50%", left: "50%",
          display: "flex", flexDirection: "column", alignItems: "center",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "95%" : 800,
          bgcolor: "background.paper", border: "2px solid #000",
          boxShadow: 24, pt: 2, px: 4, pb: 3,
        }}>
          <InfoIcon style={{ color: "Orange", fontSize: "40px" }} />
          <p id="child-modal-description" style={{ textAlign: "center", color: "#fff" }}>
            When you cancel your subscription you are also canceling the hosting of your blog pages.
          </p>
          <Stack flexDirection="row" sx={{ gap: "10px", marginTop: "2%" }}>
            <Button onClick={() => setConfirmCancelSubscription(false)} variant="contained"
              sx={{ fontWeight: "bolder", fontSize: "17px" }}>
              {cancellingLoader ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Continue"}
            </Button>
            <Button onClick={() => setConfirmCancelSubscription(false)} variant="contained"
              sx={{ fontWeight: "bolder", fontSize: "17px" }}>Exit</Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={upgradeModal} disableEscapeKeyDown
        aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
        <Box sx={{
          position: "absolute" as "absolute", top: "50%", left: "50%",
          display: "flex", flexDirection: "column", alignItems: "center",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "95%" : "40%",
          bgcolor: "background.paper", border: "2px solid #000",
          boxShadow: 24, pt: 2, px: 4, pb: 3,
          borderRadius: "15px", padding: "3%",
        }}>
          <Typography style={{ textAlign: "center", fontWeight: "bold" }}>
            <InfoIcon sx={{ color: "#ffcc00" }} /><br />
            This feature is not included in your plan. Please upgrade to have access to this feature.
          </Typography>
          <Stack flexDirection="row" sx={{ display: "flex", gap: "10px", marginTop: "1%" }}>
            <Button onClick={() => setUpgradeModal(false)} variant="contained">Close</Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={topicsList} aria-labelledby="modal-title" aria-describedby="modal-description">
        <Box sx={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          width: "70%", maxWidth: 1000,
          bgcolor: "#36393F", border: "none",
          pt: 2, px: 4, pb: 3, height: "85%", maxHeight: "110vh",
          overflow: "auto", borderRadius: "8px",
          boxShadow: "0px 50px 50px rgba(0, 0, 0, 0.5)",
        }}>
          <Stack width="100%">
            <Grid container>
              <Grid item xs={12} lg={12}>
                <Typography variant="h5" fontWeight="bold" style={{ color: "#fff" }}>Blog Topics</Typography>
                <Typography variant="h6" fontWeight="normal" style={{ color: "#fff" }}>
                  Below are some suggested topics to write about.
                </Typography>
              </Grid>
            </Grid>
            <Divider style={{ height: "2px", backgroundColor: "#CBCBCB", marginTop: "1%" }} />
            <Box sx={{ maxHeight: "38vh", overflowY: "auto", marginTop: "1%" }}>
              <RadioGroup value={selectedTopic} onChange={(e) => setSelectedTopic(e.target.value)}>
                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                  {topics && topics?.map((topic: any, index: any) => (
                    <Grid item xs={12} lg={12} style={{ padding: "0.5%", height: "50px" }} key={index}>
                      <Button fullWidth color="primary"
                        sx={{
                          textAlign: "left",
                          bgcolor: selectedTopic === topic ? "#0168B5" : "transparent",
                          color: selectedTopic === topic ? "#fff" : "#CBCBCB",
                          borderColor: "#CBCBCB",
                          "&:hover": { bgcolor: "#0168B5", color: "#fff" },
                          display: "flex", justifyContent: "flex-start", alignItems: "center",
                        }}
                        onClick={() => setSelectedTopic(topic)}>
                        <Radio checked={selectedTopic === topic} value={topic}
                          sx={{ color: "#CBCBCB", "&.Mui-checked": { color: "#4BA5EB" } }} />
                        {topic.replace(/-/g, " ")}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </RadioGroup>
            </Box>
          </Stack>
        </Box>
      </Modal>

      {/* Delete Course Confirmation Modal */}
      <Modal open={deleteCourseModal} onClose={() => setDeleteCourseModal(false)}
        aria-labelledby="delete-course-modal">
        <Box sx={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '380px', bgcolor: '#1a1a2e',
          borderRadius: '12px', boxShadow: '0px 8px 32px rgba(0,0,0,0.5)',
          p: 4, '&:focus': { outline: 'none' }, textAlign: 'center',
        }}>
          <InfoIcon sx={{ color: '#ffcc00', fontSize: 40, mb: 1 }} />
          <Typography sx={{ color: '#fff', fontWeight: 700, mb: 1, fontSize: '16px' }}>
            Are you sure you want to delete this course?
          </Typography>
          <Typography sx={{ color: '#aaa', fontSize: '13px', mb: 3 }}>
            This action cannot be undone.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="contained" sx={{ background: '#ff4444', textTransform: 'none', fontWeight: 600 }}
              onClick={() => deleteCourseId && handleDeleteCourse(deleteCourseId)}>
              Yes, Delete
            </Button>
            <Button variant="outlined" sx={{ color: '#aaa', borderColor: '#555', textTransform: 'none' }}
              onClick={() => setDeleteCourseModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Modal
        open={bulkDeleteModal}
        onClose={() => setBulkDeleteModal(false)}
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "40%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: '15px',
            padding: '3%'
          }}
        >
          <Typography variant="h6" mb={2}>
            Delete Course
          </Typography>

          <Typography mb={3}>
            Are you sure you want to delete
            <strong> {selectedCourses.length} </strong>
            selected course(s)?
            This action cannot be undone.
          </Typography>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              onClick={() => setBulkDeleteModal(false)}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={async () => {
                await handleBulkDelete();
                setBulkDeleteModal(false);
              }}
            >
              Delete Selected
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default ListingCourses;